(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('client', {
            parent: 'application',
            url: '/client?login&email',
            params: {
                login: null,
                email: null
            },
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Klienci - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/client/client.html',
                    controller: 'ClientController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
